<template>
  <a-layout>
    <a-layout-content>
      <a-page-header
        @back="this.goBack"
        :title="this.$route.meta.title"
        :sub-title="this.$route.meta.subTitle"
        class="vd-gl-header-warp"
      />
      <div class="vd-gl-content">
        <a-form-model :label-col="labelCol">
          <a-form-model-item label="小程序名">
            {{ name }}
          </a-form-model-item>
          <a-form-model-item label="按地区选择">
            <!-- 联机选择器 -->
            <a-cascader
              style="width: 328px"
              :options="areaTree"
              :field-names="{
                label: 'name',
                value: 'id',
                children: 'children',
              }"
              placeholder="请选择用户所属地区"
              :change-on-select="true"
              @change="
                (e) => {
                  this.selectPath = e;
                }
              "
            />
            <!-- 搜索 -->
            <a-button style="margin-left: 32px" @click="selectAdmin"
              >搜索</a-button
            >
          </a-form-model-item>

          <a-form-model-item label="成员列表" :label-col="labelCol">
            <div>
              <a-button size="small" @click="selectAll">
                全部选中 ({{ adminList.length }}个)</a-button
              >
              <a-button
                style="margin-left: 10px;"
                type="primary"
                size="small"
                @click="addMember"
              >
                创建 ({{ selectList.length }}个)
              </a-button>
              <a-divider />
              <template v-if="adminList.length > 0">
                <div style="height: 120px;overflow-y: scroll;">
                  <template v-for="item in adminList">
                    <a-tag :key="item.id" @click="selectItem(item)">
                      {{ item.nickname }} ({{ item.username }}) -
                      {{ item.area_name }}
                    </a-tag>
                  </template>
                </div>
              </template>
              <template v-else>
                <a-empty :description="false" />
              </template>
            </div>
          </a-form-model-item>

          <a-table
            row-key="id"
            :data-source="selectList"
            :pagination="false"
            size="small"
            :scroll="{ y: 312 }"
            :locale="{ emptyText: '请选择推广成员' }"
          >
            <a-table-column title="姓名" data-index="nickname" />
            <a-table-column title="工号" data-index="username" />
            <a-table-column title="所属地区" data-index="area_name" />
            <a-table-column title="操作">
              <template slot-scope="record">
                <a-tag color="red" @click="removeAdmin(record.id)">
                  移 除</a-tag
                >
              </template>
            </a-table-column>
          </a-table>
        </a-form-model>
      </div>
    </a-layout-content>
  </a-layout>
</template>

<script>
import { AdminByAreaApi } from "@/api";
import { auto_add_member } from "@/api/auto";
import { get_area_tree } from "@/api/auth";
export default {
  name: "Member",
  data() {
    return {
      id: undefined,
      name: undefined,
      areaTree: [],
      selectPath: [],
      adminList: [],
      selectList: [], // 选中的用户
      labelCol: { span: 4 },
      form: {
        table_pk: 0,
        name: "",
        code: "",
        uid: 0,
        task: 99,
        type: 0,
      },
    };
  },
  mounted() {
    this.id = parseInt(this.$route.query.id);
    this.name = this.$route.query.name;
    // 获取管理地区信息
    get_area_tree().then((res) => {
      if (res.code === 1) {
        this.areaTree = res.areaTree;
      }
    });
  },
  methods: {
    selectAdmin() {
      if (this.selectPath.length === 0) {
        this.$message.warning("请选择地区");
        return false;
      }
      AdminByAreaApi({ area_path: this.selectPath }).then((res) => {
        if (res["code"] === 1) {
          // 该地区下的用户
          this.adminList = res["admin_list"];
        } else {
          this.$message.warning(res["msg"]);
        }
      });
    },
    // 选中全部搜索出来的数据
    selectAll() {
      // 当前的成员列表
      if (this.adminList.length <= 0) {
        this.$message.warning("请先按地区查询推广人");
        return false;
      }
      this.adminList.forEach((item) => {
        this.selectItem(item);
      });
    },
    selectItem(item) {
      // 检测重复
      for (let i = 0; i < this.selectList.length; i++) {
        if (this.selectList[i]["id"] === item["id"]) {
          this.$message.info({
            content: "重复添加用户已自动去除",
            key: "unique_member",
          });
          return false;
        }
      }
      this.selectList.push(item);
    },
    removeAdmin(selected) {
      this.selectList = this.selectList.filter((item) => {
        return item.id !== selected;
      });
    },
    addMember() {
      this.confirmLoading = true;
      if (this.selectList.length === 0) {
        this.$message.warning("缺少参数");
        return false;
      }
      auto_add_member({
        id: this.id,
        selectList: this.selectList,
      }).then((res) => {
        if (res.code === 1) {
          // 弹出跳转查看推广员列表框
          this.$confirm({
            title: "是否跳转到推广员列表",
            okText: "确定",
            cancelText: "取消",
            content: () => res.msg,
            onOk: () => {
              this.$router.push({
                path: "/auto/member/list",
                query: {
                  id: this.id,
                },
              });
            },
            onCancel: () => {
              console.log("Cancel");
            },
          });
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
  },
};
</script>

<style scoped></style>
